import { render } from "./EventList.vue?vue&type=template&id=f538b498&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=f538b498&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f538b498"

export default script